// extracted by mini-css-extract-plugin
module.exports = {"container":"placeholder_container__n4xCY","wave":"placeholder_wave__f3UrL","text":"placeholder_text__k5Xyo","rect":"placeholder_rect__frx37","circle":"placeholder_circle__75RGL"};